import { Component, Output, EventEmitter, OnDestroy } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";

import { CardElement } from "src/app/shared/modules/stripe";
import { MyqqStripeService } from "src/app/core/services/myqq-stripe/myqq-stripe.service";

import { PaymentMethodResult } from "src/app/shared/modules/stripe/stripe-definitions/payment-method";

@Component({
  selector: "myqq-lookup-account-credit-card",
  templateUrl: "./lookup-credit-card.component.html",
  styleUrls: ["./lookup-credit-card.component.scss"],
})
export class LookupAccountCreditCardComponent implements OnDestroy {
  @Output()
  submitToken = new EventEmitter<PaymentMethodResult>();
  @Output()
  cancel = new EventEmitter();
  @Output()
  error = new EventEmitter<{ message: string; error: Error; data: any }>();
  @Output()
  last4 = new EventEmitter();

  card = new FormControl(null, [Validators.requiredTrue]);

  tokenizing = false;
  destroyed = false;

  cardError: string;

  readonly form = this.fb.group({
    name: ["", [Validators.required]],
    address_country: ["US", [Validators.required]],
  });

  constructor(readonly fb: FormBuilder, readonly stripe: MyqqStripeService) {}

  ngOnDestroy() {
    this.destroyed = true;
  }

  async handleTokenize(metadata: any) {
    if (this.form.valid && !!this.card.value) {
      this.tokenizing = true;
      try {
        const paymentMethod = await this.stripe.createPaymentMethod({
          card: this.card.value as CardElement,
          type: "card",
        });

        if (paymentMethod) {
          if (!this.destroyed) {
            this.handleNext(paymentMethod);
          }
        }
      } catch (error) {
        this.error.emit({
          message: "Stripe createToken failed",
          error: error,
          data: metadata,
        });
      }
      this.tokenizing = false;
    }
  }

  handleNext(result: PaymentMethodResult) {
    this.submitToken.emit(result);
  }

  handleCancel() {
    this.cancel.emit();
  }

  handleLast4() {
    this.last4.emit();
  }

  handleChange(value) {
    this.cardError = value.error?.message;
  }
}
